import React from 'react';
import { Tooltip } from 'antd';
import Select from 'react-select';
import { bool, string, array, object, oneOfType } from 'prop-types';

import SvgIcon from '../svg-icon';
import { theme } from '../../styles';
import { InvitationLink } from '../../modals/manage-users-modal/styled-components';
import { RequestStatusDescription } from '../requests-list-item/request-header/styled-components';

const getSelectStyles = props => ({
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    alignItems: 'flex-start',
    padding: 6,
    color: state.isMulti ? theme.colors.backgroundDarkSilver : theme.colors.white,
  }),
  input: base => ({
    ...base,
    padding: 0,
    height: 20,
  }),
  singleValue: base => ({
    ...base,
    fontSize: 15,
    fontWeight: 500,
    marginLeft: 8,
    color: theme.colors.white,
  }),
  placeholder: base => ({
    ...base,
    fontSize: 14,
  }),
  control: (base, state) => ({
    ...base,
    width: (!props.form && '100%') || (state.isMulti ? 245 : 190),
    maxWidth: props.maxWidth || 245,
    minHeight: 35,
    backgroundColor: state.isDisabled
      ? theme.colors.backgroundLightSilver
      : props.color || theme.colors.white,
    borderColor: state.isDisabled
      ? theme.colors.borderLightestSilver
      : props.color || theme.colors.borderOrange,
    '&:hover': {
      borderColor: props.color || theme.colors.borderOrange,
    },
    boxShadow: 'none',
    '.info': !state.isMulti
      ? { display: 'none' }
      : {},
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    color: state.isSelected
      ? theme.colors.white
      : theme.colors.fontSilverPrimary,
    backgroundColor: state.isSelected
      ? theme.colors.tangerinePrimary
      : theme.colors.white,
    ':hover': {
      backgroundColor: state.isSelected
        ? theme.colors.tangerinePrimary
        : theme.colors.tangerineLight,
    },
    '&:active': {
      backgroundColor: theme.colors.tangerinePrimary,
      color: theme.colors.white,
    },
  }),
  valueContainer: base => ({
    ...base,
    padding: 2,
    minWidth: 0,
    '& + div': {
      alignItems: 'center',
    },
    input: {
      height: 'auto',
    },
  }),
  menu: (styles, state) => ({
    ...styles,
    width: (!props.form && '100%') || (state.isMulti ? 245 : 190),
    maxWidth: props.maxWidth || 245,
    zIndex: 100,
  }),
  menuList: base => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    fontWeight: 400,
    div: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingRight: 0,
      color: theme.colors.mainDark,
    },
    '.info': {
      display: 'flex',
      alignItems: 'center',
      padding: '0 10px',
      margin: '-10px 0',
      cursor: 'pointer',
      position: 'relative',
      '&:after, &:before': {
        position: 'absolute',
        content: '',
        width: 36,
        height: 10,
      },
      '&::after': {
        right: 0,
        top: -10,
      },
      '&::before': {
        right: 0,
        bottom: -10,
      },
    },
    '.select-item': {
      width: '100%',
      zIndex: 3,
      div: {
        whiteSpace: 'inherit',
        marginRight: '0px !important',
        maxWidth: '100%',
      },
    },
    maxHeight: 200,
    opacity: props.isTransparent && 0.5,
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    '.select-item': {
      zIndex: 0,
    },
    backgroundColor: data.color,
    borderRadius: 3,
    margin: 1,
    maxWidth: '95%',
    textAlign: 'center',
    div: {
      fontSize: 'inherit',
    },
    'div:first-child': {
      position: 'relative',
    },
    '.info': {
      position: 'absolute',
      right: 0,
      bottom: -2,
      paddingLeft: 5,
    },
  }),
  multiValueLabel: styles => ({
    ...styles,
    color: theme.colors.white,
    flex: 1,
    minWidth: 0,
  }),
  multiValueRemove: styles => ({
    ...styles,
    color: theme.colors.white,
    flexShrink: 1,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'inherit',
    },
  }),
});

const StyledSelect = props => (
  <Select
    {...props}
    styles={getSelectStyles(props)}
    getOptionLabel={({ label, description, ...rest }) =>
      (<div
        className="select-item"
      >
        <InvitationLink style={{ marginRight: props.isMulti && description ? 20 : 0 }}>
          <span>{label}</span>
        </InvitationLink>
        {description
          ? <Tooltip
            title={
              <RequestStatusDescription
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
                onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
              >
                {description}
              </RequestStatusDescription>
            }
          >
            <span
              className="info"
              onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
            >
              <SvgIcon
                type="info"
                color={props.isMulti && props.value.map(({ value }) => value).includes(rest.value)
                  ? theme.colors.white
                  : theme.colors.secondaryDark}
                fillOpacity={1}
                isWithoutHover
              />
            </span>
          </Tooltip>
          : ''}
      </div>)
    }
  />
);

StyledSelect.propTypes = {
  name: string,
  isMulti: bool,
  value: oneOfType([array, object]).isRequired,
};

StyledSelect.defaultProps = {
  name: '',
  isMulti: false,
};

export default StyledSelect;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/styled-select.js